export default {
  eyebrow: 'Portal de partner',
  title: 'Cuenta',
  description: 'Los detalles de tu cuenta de partner.',
  page: {
    read_only_notice: 'Solo lectura. Haz clic en Editar para cambiar cualquier valor.',
    editing_notice: 'Editando — los cambios son visibles para tu equipo y clientes.',
  },
  profile: {
    form: {
      name: {
        label: 'Nombre del partner',
        hint: 'El nombre legal / de la entidad. Se usa en documentos de facturación.',
      },
      display_name: {
        label: 'Nombre visible para el consumidor',
        hint: 'La etiqueta «Powered by ___» que tus clientes ven en tus restaurantes. Si se deja en blanco, se usa el nombre del partner.',
      },
      support_email: {
        label: 'Correo electrónico de contacto',
        hint: 'Donde Foodamigos y tus clientes pueden contactarte. Tu correo de acceso no cambia.',
      },
      invoicing_emails: {
        label: 'Correos de facturas',
        hint: 'Los recibos de las facturas emitidas a su nombre se envían a cada una de estas direcciones. Déjelo vacío para usar su correo de inicio de sesión.',
        placeholder: 'Su correo de inicio de sesión',
      },
    },
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'No se pudieron cargar los detalles de tu cuenta.',
    failed_to_save_changes: 'No se pudieron guardar los cambios',
    changes_got_saved: 'Los cambios se guardaron',
  },
};
